/* Forte PDP — add to cart + sticky bar.
   One product form (#fpdp-product-form) drives both the buy box button and the
   sticky bar button; the sticky button uses form="fpdp-product-form" so it
   submits the same variant / selling plan / quantity. */
(function () {
  'use strict';

  var form = document.querySelector('[data-fpdp-form]');
  var sticky = document.querySelector('[data-fpdp-sticky]');
  var msg = document.querySelector('[data-fpdp-msg]');

  /* ---------- quantity stepper ----------
     Sole owner of the +/- buttons; the buy box section deliberately does not
     bind them too. The value posts to /cart/add.js straight off the form, so
     the input has to stay a valid whole number the server will accept. */
  document.querySelectorAll('.fpdp-bb__qty').forEach(function (box) {
    var input = box.querySelector('.fpdp-bb__qty-val');
    if (!input) return;

    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 1;
    var max = parseInt(input.max, 10);

    function set(n) {
      if (isNaN(n)) n = min;
      n = Math.max(min, n);
      if (!isNaN(max)) n = Math.min(max, n);
      if (String(n) === input.value) return;
      input.value = n;
      // Let anything listening on the form (price readouts, apps) react.
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    box.querySelectorAll('.fpdp-bb__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = parseInt(input.value, 10);
        if (isNaN(n)) n = min;
        set(btn.dataset.qty === 'up' ? n + 1 : n - 1);
      });
    });

    // Typing straight into the field can leave it empty, 0 or "1e5".
    input.addEventListener('change', function () { set(parseInt(input.value, 10)); });
    input.addEventListener('blur', function () { set(parseInt(input.value, 10)); });
  });

  /* ---------- sticky bar visibility ---------- */
  var reveal = sticky ? sticky.dataset.reveal : 'scroll';

  function showSticky() {
    if (!sticky || !sticky.hidden) return;
    sticky.hidden = false;
    requestAnimationFrame(function () { sticky.classList.add('is-visible'); });
  }
  function hideSticky() {
    if (!sticky || sticky.hidden) return;
    sticky.classList.remove('is-visible');
    sticky.hidden = true;
  }

  if (sticky) {
    if (reveal === 'always') {
      showSticky();
    } else if (reveal === 'scroll') {
      // Reveal once the buy box's own ATC row has scrolled out of view.
      var anchor = document.querySelector('.fpdp-bb__atc-row');
      if (anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.boundingClientRect.top < 0 && !e.isIntersecting) showSticky();
            else hideSticky();
          });
        }, { rootMargin: '0px 0px 0px 0px', threshold: 0 }).observe(anchor);
      } else {
        showSticky();
      }
    }
    // reveal === 'atc' stays hidden until a successful add below.
  }

  /* ---------- cart count ---------- */
  function refreshCount(count) {
    document.querySelectorAll('.fpdp-header__cart').forEach(function (link) {
      var badge = link.querySelector('.fpdp-header__cart-count');
      if (!count) { if (badge) badge.remove(); return; }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'fpdp-header__cart-count';
        link.appendChild(badge);
      }
      badge.textContent = count;
    });
  }

  function setMsg(text, isError) {
    if (!msg) return;
    msg.textContent = text || '';
    msg.classList.toggle('is-error', !!isError);
  }

  /* ---------- add to cart ---------- */
  if (form) {
    /* Capture phase on the document rather than a listener on the form itself.
       SlideCart HQ binds its own submit handler to any add-to-cart form and
       fires a second /cart/add XHR of its own, so one click added the item
       twice — ours went out as multipart, theirs url-encoded. A capture
       listener runs before anything bound on the form whatever order the app
       loaded in, and stopPropagation means the event never reaches it. Matched
       by id so it survives the section being re-rendered in the editor. */
    document.addEventListener('submit', function (e) {
      /* Matched with matches() rather than `.id`: the form contains the variant
         <input name="id">, and a form's named-control getter shadows the `id`
         property — `form.id` hands back that input element, so a string compare
         here silently never matched. */
      var f = e.target;
      if (!f || !f.matches || !f.matches('#fpdp-product-form')) return;

      e.preventDefault();
      e.stopPropagation();

      var buttons = document.querySelectorAll('[data-fpdp-submit]');
      buttons.forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); });
      setMsg('');

      /* Show the drawer straight away. It is already in the page, so waiting
         for the add and the section re-render before revealing it just made
         the cart feel slow. It refreshes in place once the add lands. */
      if (typeof window.FORTE_CART_OPEN === 'function') window.FORTE_CART_OPEN();

      var data = new FormData(f);
      // An empty selling_plan means "one-time" — Shopify rejects a blank value.
      if (!data.get('selling_plan')) data.delete('selling_plan');

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart.');
          setMsg('Added to cart.');
          if (reveal === 'atc') showSticky();
          /* The drawer's own refresh already fetches the cart and hands it
             back, so the count comes from that one response instead of this
             file fetching /cart.js all over again.

             The SlideCart app overwrites window.SLIDECART_OPEN with its own
             drawer once its embed loads, so that alias is only a fallback for
             when the Forte drawer is not on the page at all. */
          if (typeof window.FORTE_CART_REFRESH === 'function') {
            return window.FORTE_CART_REFRESH().then(function (cart) {
              if (cart) refreshCount(cart.item_count);
            });
          }

          if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
          if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { refreshCount(cart.item_count); });
        })
        .catch(function (err) { setMsg(err.message, true); })
        .finally(function () {
          buttons.forEach(function (b) { b.disabled = false; b.classList.remove('is-loading'); });
        });
    }, true);
  }
})();

/* Forte PDP — product gallery: thumbnails, arrows, zoom, and the
   subscribe/one-time price switch. */
(function () {
  'use strict';

  var stage = document.querySelector('[data-fpdp-gallery]');
  if (!stage) return;

  var slides = [].slice.call(stage.querySelectorAll('[data-fpdp-slide]'));
  var thumbs = [].slice.call(document.querySelectorAll('[data-fpdp-thumb]'));
  var track = stage.querySelector('[data-fpdp-track]');
  var index = 0;

  /* On mobile the track is a scroll-snap row (Figma #7323:83): the slides sit
     side by side and the one nearest the middle is the active one. Above 749
     the track has no box of its own and the slides stack in the stage. */
  function isRow() {
    return !!track && track.scrollWidth > track.clientWidth + 1;
  }

  function mark(i) {
    index = (i + slides.length) % slides.length;
    slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
    thumbs.forEach(function (t, n) {
      t.classList.toggle('is-active', n === index);
      t.setAttribute('aria-current', n === index ? 'true' : 'false');
    });
  }

  function show(i) {
    if (!slides.length) return;
    mark(i);
    if (isRow()) {
      var el = slides[index];
      var left = el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2;
      if (track.scrollTo) track.scrollTo({ left: left, behavior: 'smooth' });
      else track.scrollLeft = left;
      return;
    }
    var active = thumbs[index];
    if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest' });
  }

  /* Swiping: whichever slide is closest to the centre becomes active. */
  if (track) {
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (!isRow()) return;
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestD = Infinity;
        slides.forEach(function (s, n) {
          var d = Math.abs((s.offsetLeft + s.offsetWidth / 2) - mid);
          if (d < bestD) { bestD = d; best = n; }
        });
        if (best !== index) mark(best);
      }, 60);
    }, { passive: true });
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { show(parseInt(t.dataset.fpdpThumb, 10) || 0); });
  });

  var prev = document.querySelector('[data-fpdp-prev]');
  var next = document.querySelector('[data-fpdp-next]');
  if (prev) prev.addEventListener('click', function () { show(index - 1); });
  if (next) next.addEventListener('click', function () { show(index + 1); });

  // Keyboard support while the gallery has focus.
  stage.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') show(index - 1);
    if (e.key === 'ArrowRight') show(index + 1);
  });

  /* ---------- zoom ---------- */
  var zoomBtn = document.querySelector('[data-fpdp-zoom]');
  if (zoomBtn) {
    zoomBtn.addEventListener('click', function () {
      var img = slides[index];
      if (!img) return;
      var box = document.createElement('div');
      box.className = 'fpdp-zoom';
      // Start from the image already decoded on the page so the overlay is
      // never empty, then swap in the full-resolution file once it loads.
      var shown = img.currentSrc || img.src;
      box.innerHTML =
        '<button type="button" class="fpdp-zoom__close" aria-label="Close">&times;</button>' +
        '<img src="' + shown + '" alt="' + (img.alt || '') + '">';
      document.body.appendChild(box);
      var full = img.dataset.full;
      if (full && full !== shown) {
        var hi = new Image();
        hi.onload = function () { var el = box.querySelector('img'); if (el) el.src = full; };
        hi.src = full;
      }
      /* The site header paints above this overlay, so a full-viewport box put
         the top of the photo behind the nav. Start the overlay under whatever
         is currently docked up there instead — measured rather than hard-coded,
         because the announcement bar and the header are different heights on
         mobile and desktop and either can be absent. */
      function fitBelowHeader() {
        var bottom = 0;
        ['header.theme__header', '.header-group', '.fpdp-announcement'].forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            var r = el.getBoundingClientRect();
            if (r.height > 0 && r.bottom > bottom) bottom = r.bottom;
          });
        });
        // Never eat more than a third of the screen, whatever an app injects.
        var cap = (window.innerHeight || 0) / 3;
        if (bottom > cap) bottom = cap;
        box.style.top = Math.max(0, Math.round(bottom)) + 'px';
      }

      fitBelowHeader();
      window.addEventListener('resize', fitBelowHeader);

      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () { box.classList.add('is-open'); });
      function close() {
        box.classList.remove('is-open');
        document.body.style.overflow = '';
        setTimeout(function () { box.remove(); }, 200);
        document.removeEventListener('keydown', onKey);
        window.removeEventListener('resize', fitBelowHeader);
      }
      function onKey(e) { if (e.key === 'Escape') close(); }
      box.addEventListener('click', function (e) { if (e.target !== box.querySelector('img')) close(); });
      document.addEventListener('keydown', onKey);
    });
  }

  /* ---------- selected-card styling ---------- */
  function paintSelection() {
    document.querySelectorAll('.fpdp-bb__offer').forEach(function (card) {
      var input = card.querySelector('.fpdp-bb__offer-input');
      card.classList.toggle('is-selected', !!(input && input.checked));
    });
  }
  paintSelection();
  document.querySelectorAll('.fpdp-bb__offer-input').forEach(function (r) {
    r.addEventListener('change', paintSelection);
  });

})();

/* Forte PDP — running total.
   `unit price x quantity` drives three things that must never disagree: the
   buy box button, the sticky bar button, and the free-shipping meter. One
   recalc owns all of them, and it re-runs on both inputs — the offer radios
   (subscribe vs one-time change the unit price) and the quantity stepper.
   The server already rendered the correct state for quantity 1, so with JS
   off nothing here is load-bearing. */
(function () {
  'use strict';

  var form = document.querySelector('[data-fpdp-form]');
  if (!form) return;

  var qtyInput = form.querySelector('.fpdp-bb__qty-val');
  var ship = document.querySelector('[data-fpdp-ship]');
  var lead = form.dataset.lead || 'ADD TO CART';
  var goal = parseInt(form.dataset.shipGoal, 10) || 0;
  /* This store's money_format is `<span class=money>${{amount}}</span>` — the
     currency converter's wrapper. We write through textContent, so the tags
     would show up as literal text; strip them, the same way the Liquid side
     does with `| money | strip_html`. */
  var format = (form.dataset.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');

  /* Shopify's money_format is a template, not a currency code — reimplement
     the placeholders it can contain rather than assuming "$" and ".". */
  function money(cents) {
    function group(n, thousands, decimal, places) {
      var fixed = (Math.abs(n) / 100).toFixed(places);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return places && parts[1] ? whole + decimal + parts[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount_no_decimals': return group(cents, ',', '.', 0);
        case 'amount_with_comma_separator': return group(cents, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return group(cents, '.', ',', 0);
        case 'amount_with_apostrophe_separator': return group(cents, "'", '.', 2);
        case 'amount_no_decimals_with_space_separator': return group(cents, ' ', ',', 0);
        case 'amount_with_space_separator': return group(cents, ' ', ',', 2);
        default: return group(cents, ',', '.', 2);
      }
    });
  }

  function unitCents() {
    var picked = form.querySelector('input[name="selling_plan"]:checked') ||
      document.querySelector('.fpdp-bb__offer-input:checked');
    var n = picked ? parseInt(picked.dataset.unitCents, 10) : NaN;
    return isNaN(n) ? 0 : n;
  }

  function quantity() {
    var n = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : n;
  }

  function recalc() {
    var total = unitCents() * quantity();

    // Both buttons carry this hook, so they move together.
    document.querySelectorAll('[data-fpdp-atc-label]').forEach(function (el) {
      if (el.textContent.trim() === 'SOLD OUT') return;
      el.textContent = lead + ' — ' + money(total);
    });

    if (!ship || !goal) return;
    var left = goal - total;
    var text = ship.querySelector('[data-fpdp-ship-text]');
    var fill = ship.querySelector('[data-fpdp-ship-fill]');
    var price = ship.querySelector('[data-fpdp-ship-price]');

    if (text) {
      // Copy comes from the section settings, so the merchant still owns it.
      var strong = document.createElement('strong');
      if (left > 0) {
        strong.textContent = money(left) + ' ' + (ship.dataset.away || '');
        text.textContent = '';
        text.appendChild(strong);
        text.appendChild(document.createTextNode(ship.dataset.rest || ''));
      } else {
        strong.textContent = ship.dataset.done || '';
        text.textContent = '';
        text.appendChild(strong);
      }
    }
    if (fill) {
      var pct = Math.max(0, Math.min(100, Math.round((total / goal) * 100)));
      fill.style.width = pct + '%';
      var bar = fill.parentElement;
      if (bar) bar.setAttribute('aria-valuenow', pct);
    }
    if (price) price.textContent = money(total);
  }

  document.querySelectorAll('.fpdp-bb__offer-input').forEach(function (r) {
    r.addEventListener('change', recalc);
  });
  if (qtyInput) {
    // The stepper fires input+change after clamping, so this covers +/- and typing.
    qtyInput.addEventListener('change', recalc);
    qtyInput.addEventListener('input', recalc);
  }

  recalc();
})();

/* Forte PDP — suppress the subscription app's own widget.
   Recharge finds any form[action="/cart/add"] and injects `.rc-container-wrapper`
   (its one-time / subscribe selector) into it. The Forte buy box already provides
   that UI per the Figma comp and drives the native `selling_plan` input, so the
   app's copy is a visual duplicate AND a second source of plan inputs in the same
   form. Remove the node rather than hide it, so nothing stray gets submitted.
   Scoped to this template — the app keeps working on every other product page. */
(function () {
  'use strict';

  var SEL = '.rc-container-wrapper, .rc-container, .rc-widget';

  function strip(root) {
    (root || document).querySelectorAll(SEL).forEach(function (el) {
      if (el.closest('.fpdp-buybox') || el.closest('[data-fpdp-form]')) el.remove();
    });
  }

  strip();
  if (!document.querySelector('.fpdp-buybox')) return;

  // It mounts asynchronously, so keep watching for a while after load.
  var obs = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches(SEL)) { if (n.closest('.fpdp-buybox') || n.closest('[data-fpdp-form]')) n.remove(); return; }
        strip(n);
      });
    });
  });
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { obs.disconnect(); }, 15000);
})();
